import EvolvabilityCouplingChart from "../../../../src/components/evolvabilityCouplingChart.js";
import * as React from 'react';
export default {
  EvolvabilityCouplingChart,
  React
};